import BaseClass from "../BaseClass";

export default class ResizeHandler extends BaseClass {

    constructor(element) {
        super(element);
        this.showChat = true;

        this.isResizing = false;
        this.startWidth = null;
        this.startHeight = null;
        this.startMouseX = null;
        this.startMouseY = null;

        this.resize = this.resize.bind(this);
        this.stopResize = this.stopResize.bind(this);
        this.boundResetSizes = this.resetSizes.bind(this);

        this.touchStartResize = this.touchStartResize.bind(this);
        this.touchResize = this.touchResize.bind(this);
        this.touchStopResize = this.touchStopResize.bind(this);

        this.init();
    }

    init() {
        let mySelf = this;

        this.$videoContainer = this.$element.find('[data-id="video-container"]').first();
        this.$chatContainer = this.$element.find('[data-id="chat-container"]').first();
        this.$camChatContainer = this.$element.find('[data-id="camchat-container"]').first();
        this.$videoHolder = this.$element.find('[data-id="video-holder"]').first();
        this.$resizer = this.$element.find('[data-id="resizer"]').first();
        this.$toggleChatBtn = this.$element.find('[data-id="toggleChat"]').first();
        this.$toggleChatBtn.find('.icon-hide-chat').hide();
        this.$toggleChatBtn.find('.icon-show-chat').show();

        if (this.$videoHolder != undefined) {
            this.$videoHolder[0].style.height = '100%';
            this.$videoHolder[0].scrollLeft = (this.$videoHolder[0].scrollWidth - this.$videoHolder[0].clientWidth) / 2;
            this.$videoHolder[0].scrollBehavior = 'smooth';
        }

        this.$toggleChatBtn.on('click', function () {
            mySelf.toggleChat();
        });

        this.$resizer.on('mousedown', function (e) {
            mySelf.startResize(e);
        });

        this.$resizer.on('touchstart', function (e) {
            mySelf.touchStartResize(e);
        });

        $(document).on("content:resized", this.boundResetSizes);
    }

    toggleChat() {
        this.showChat = !this.showChat;
        this.$videoHolder[0].style.height = '100%';

        if (!this.showChat) {
            this.$chatContainer.hide();
            this.$resizer.hide();
            this.$toggleChatBtn.find('.icon-hide-chat').show();
            this.$toggleChatBtn.find('.icon-show-chat').hide();
            this.$videoHolder.addClass('fillHeight');

            if (window.innerWidth <= 991) {
                this.$videoContainer[0].style.width = '100%';
                this.$videoContainer[0].style.height = '100%';
            } else {
                this.$videoContainer[0].style.width = '';
                this.$videoContainer[0].style.height = '';
            }
        } else {
            this.$chatContainer.show();
            this.$resizer.show();
            this.$toggleChatBtn.find('.icon-hide-chat').hide();
            this.$toggleChatBtn.find('.icon-show-chat').show();
            this.$videoHolder.removeClass('fillHeight');

            if (window.innerWidth <= 991) {
                this.$videoContainer[0].style.width = '100%';
                this.$videoContainer[0].style.height = '65%';
            } else {
                this.$videoContainer[0].style.width = '';
                this.$videoContainer[0].style.height = '';
            }
        }

        this.$videoHolder[0].scrollLeft = (this.$videoHolder[0].scrollWidth - this.$videoHolder[0].clientWidth) / 2;
        this.$videoHolder[0].scrollBehavior = 'smooth';
    }

    resetSizes() {
        this.$videoHolder[0].style.height = '100%';

        if (window.innerWidth <= 991) {
            if (this.showChat) {
                this.$videoContainer[0].style.width = '100%';
                this.$videoContainer[0].style.height = '65%';
            } else {
                this.$videoContainer[0].style.width = '100%';
                this.$videoContainer[0].style.height = '100%';
            }
        } else {
            if (this.showChat) {
                this.$videoContainer[0].style.width = '';
                this.$videoContainer[0].style.height = '';
            } else {
                this.$videoContainer[0].style.width = '';
                this.$videoContainer[0].style.height = '';
            }
        }

        this.$videoHolder[0].scrollLeft = (this.$videoHolder[0].scrollWidth - this.$videoHolder[0].clientWidth) / 2;
        this.$videoHolder[0].scrollBehavior = 'smooth';
    }

    calcHeight(deltaY) {
        const newHeight = ((this.startHeight + deltaY) / this.$element[0].offsetHeight) * 100;

        if (newHeight > 25 && newHeight < 55) {
            this.$videoContainer[0].style.height = `${newHeight}%`;
        }
    }

    calcWidth(deltaX) {
        const newWidth = ((this.startWidth + deltaX) / this.$element[0].offsetWidth) * 100;
        const videoHeight = this.$videoHolder[0].offsetHeight;

        if ((newWidth > 25 && videoHeight < this.$camChatContainer[0].offsetHeight) ||
            (this.startWidth + deltaX < this.$videoContainer[0].offsetWidth && videoHeight >= this.$camChatContainer[0].offsetHeight)) {
            this.$videoContainer[0].style.width = `${newWidth}%`;
        }
    }

    startResize(e) {
        this.isResizing = true;
        this.startWidth = this.$videoContainer[0].offsetWidth;
        this.startHeight = this.$videoContainer[0].offsetHeight;
        this.startMouseX = e.clientX;
        this.startMouseY = e.clientY;

        document.body.style.userSelect = "none";
        document.body.style.pointerEvents = "none";
        document.body.style.cursor = window.innerWidth < 991 ? "row-resize" : "col-resize";

        document.addEventListener('mousemove', this.resize);
        document.addEventListener('mouseup', this.stopResize);
    }

    resize(e) {
        if (!this.isResizing) return;

        this.$videoHolder[0].style.height = 'auto';

        if (window.innerWidth < 991) {
            const deltaY = e.clientY - this.startMouseY;
            this.calcHeight(deltaY);
        } else {
            const deltaX = e.clientX - this.startMouseX;
            this.calcWidth(deltaX);
        }
    }

    stopResize() {
        this.isResizing = false;

        document.body.style.userSelect = "";
        document.body.style.pointerEvents = "";
        document.body.style.cursor = "default";

        document.removeEventListener('mousemove', this.resize);
        document.removeEventListener('mouseup', this.stopResize);
    }

    touchStartResize(e) {
        const touch = e.touches[0];
        this.isResizing = true;
        this.startWidth = this.$videoContainer[0].offsetWidth;
        this.startHeight = this.$videoContainer[0].offsetHeight;
        this.startMouseX = touch.clientX;
        this.startMouseY = touch.clientY;

        document.body.style.cursor = window.innerWidth < 991 ? "row-resize" : "col-resize";
        document.addEventListener('touchmove', this.touchResize);
        document.addEventListener('touchend', this.touchStopResize);
    }

    touchResize(e) {
        if (!this.isResizing) return;

        this.$videoHolder[0].style.height = 'auto';
        const touch = e.touches[0];

        if (window.innerWidth < 991) {
            const deltaY = touch.clientY - this.startMouseY;
            this.calcHeight(deltaY);
        } else {
            const deltaX = touch.clientX - this.startMouseX;
            this.calcWidth(deltaX);
        }
    }

    touchStopResize() {
        this.isResizing = false;
        document.body.style.cursor = "default";
        document.removeEventListener('touchmove', this.touchResize);
        document.removeEventListener('touchend', this.touchStopResize);
    }

    destroyListener() {
        this.$element.off('mousedown', this.startResize);
        this.$element.off('touchstart', this.touchStartResize);
        $(document).off("content:resized", this.boundResetSizes);
    }
}